import { render, staticRenderFns } from "./cryptostatement.vue?vue&type=template&id=58e313b0&scoped=true&"
import script from "./cryptostatement.vue?vue&type=script&lang=js&"
export * from "./cryptostatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e313b0",
  null
  
)

export default component.exports